"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const news_archive_json_1 = __importDefault(require("../data/news/news_archive.json"));
const getDom_1 = __importDefault(require("../util/getDom"));
const util_1 = require("../util/util");
const Collection_1 = __importDefault(require("./Collection"));
const newsArchive = news_archive_json_1.default;
const BASE_URL = `https://secure.runescape.com/m=news/archive?oldschool=1`;
class News extends Collection_1.default {
    fetchRecent() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetchMonth(util_1.getDate());
        });
    }
    fetchPageContent(link) {
        return __awaiter(this, void 0, void 0, function* () {
            const { document: dom } = yield getDom_1.default(link);
            const contentEl = dom.getElementsByClassName('news-article-content')[0];
            if (!contentEl || !contentEl.textContent) {
                // TODO
                throw new Error('News page missing content element. Most likely being ratelimited.');
            }
            const content = contentEl.textContent.trim();
            const description = dom.querySelector('head meta').content.trim();
            return {
                content,
                description
            };
        });
    }
    decrementDate({ year, month }) {
        if (month === 1) {
            return {
                year: year - 1,
                month: 12
            };
        }
        else {
            return {
                year,
                month: month - 1
            };
        }
    }
    fetchNewArticles(date = util_1.getDate()) {
        return __awaiter(this, void 0, void 0, function* () {
            let articles = [
                ...(yield this.fetchMonth(date, false)),
                ...(yield this.fetchMonth(this.decrementDate(date), false))
            ];
            // If every article in the last 2 months of news is already in News, return.
            if (articles.every((article) => this.some((_article) => _article.link === article.link))) {
                return undefined;
            }
            const newArticles = [];
            // If the fetched articles doesn't contain all of the missing articles, keep fetching more.
            while (!articles.some((article) => this.some((_article) => article.link === _article.link))) {
                // Decrement the date by 1 month, and then fetch the previous month.
                const newDate = this.decrementDate(date);
                const nextMonth = yield this.fetchMonth({ year: newDate.year, month: newDate.month }, false);
                if (!nextMonth)
                    throw new Error('Unexpected error');
                articles = [...articles, ...nextMonth];
            }
            // Return the new articles from the fetched articles.
            for (const article of articles) {
                if (this.some((_article) => _article.link === article.link))
                    continue;
                this.set(article.link, article);
                newArticles.push(article);
            }
            return newArticles;
        });
    }
    fetchMonth({ year, month }, cache = true, pageNumber = 1) {
        return __awaiter(this, void 0, void 0, function* () {
            let newsArticlesCollection = [];
            const { document: dom } = yield getDom_1.default(this.generateNewsURL(year, month, pageNumber));
            const newsArticles = Array.from(dom.querySelectorAll('#newsSection .news-list-article'));
            for (const article of newsArticles) {
                const titleEl = article.getElementsByClassName('news-list-article__title-link')[0];
                const title = titleEl.textContent;
                const link = titleEl.href;
                const image = article.getElementsByClassName('news-list-article__figure-img')[0].src;
                const date = article.getElementsByClassName('news-list-article__date')[0].dateTime;
                const category = article.getElementsByClassName('news-list-article__category')[0]
                    .textContent;
                if (!title || !date || !category || !link || !year || !month) {
                    // TODO
                    throw new Error('News article is missing a required element.');
                }
                const newsItem = {
                    title,
                    image,
                    category,
                    link,
                    year,
                    month,
                    day: parseInt(date.split('-')[2]),
                    date: Date.parse(date)
                };
                if (cache) {
                    this.set(link, newsItem);
                }
                newsArticlesCollection.push(newsItem);
            }
            // Recursively fetch extra pages, if present.
            if (Array.from(dom.querySelectorAll('#nextNews')).length > 0) {
                const nextPage = yield this.fetchMonth({ year, month }, true, pageNumber + 1);
                newsArticlesCollection = [...newsArticlesCollection, ...nextPage];
            }
            return newsArticlesCollection;
        });
    }
    generateNewsURL(year, month, page = 1) {
        return `${BASE_URL}&year=${year}&month=${month}&page=${page}`;
    }
}
const news = new News();
for (const article of newsArchive) {
    news.set(article.link, article);
}
exports.default = news;
//# sourceMappingURL=News.js.map